<ng-container *ngIf="true">
  <div [ngbTooltip]="disabled? ('lang.globals.noTermInput' | translate) :null" container="body"
       [ngClass]="disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
       class="card blue-bg noselect content-card mr-1" tabindex="0"
       (click)="click()" (mousedown)="preventBlur()">
    <div style="margin: auto;" class="noselect">
      <sb-icon class="icon-in-btn" [ngClass]="disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
               icon="chevronUp"></sb-icon>
    </div>
    <div class="mydropdown" #thedropdown [ngClass]="visible ? 'visible' : ''" (blur)="hide()" tabindex="1">
      <button *ngFor="let option of options" class="dropdown-item" type="button" (click)="onClick(option)"
              (mousedown)="preventBlur()">
        <!--<fa-icon class="mr-3" [icon]="option.icon"></fa-icon>-->
        <b>{{option}}</b>
      </button>
      <hr>
    </div>
  </div>
</ng-container>
